//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 25/04/2025
// Version       : 1
// Description   : Agregar productos para el reporte de combustibles
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  TextField,
  Stack,
  DialogTitle,
  DialogContent,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AgregarProducto(props) {
  const [datosProducto, setDatosProducto] = useState({
    nombre: null,
    unidad: null,
  });
  const [unidades, setUnidades] = useState([]);

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("success"); // "success" | "error"

  //*************************************************************************************************************************************/

  // DESHABILITAR BOTON AL GUARDAR
  const [disBtn, setDisBtn] = useState(false);

  //*************************************************************************************************************************************/

  const obtenerUnidades = () => {
    fetch(UrlApi + "/productos_reporte/unidad")
      .then((data) => data.json())
      .then((data) => setUnidades(data));
  };

  useEffect(() => {
    obtenerUnidades();
  }, []);

  //*************************************************************************************************************************************/

  // Función GUARDAR
  const guardarCrear = async (e) => {
    e.preventDefault();
    setDisBtn(true);

    // Limpio espacios al inicio y al final con trim()
    const nombreLimpio = datosProducto.nombre
      ? datosProducto.nombre.trim()
      : "";

    // Si después de trim() queda vacío, muestra error y detiene el guardado
    if (!nombreLimpio) {
      setSeverity("error");
      setColorMensaje("#F1948A");
      setMensaje("El nombre no puede estar vacío.");
      setOpenSnack(true);
      setDisBtn(false);
      return;
    }

    try {
      const res = await fetch(UrlApi + "/productos_reporte", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nombre: nombreLimpio,
          unidad: datosProducto.unidad,
          estado: 1, // Hago que los productos guardados estén activos por defecto
        }),
      });
      const data = await res.json();

      if (res.ok) {
        setSeverity("success");
        setColorMensaje("#D4EFDF");
        setMensaje("El producto se guardó exitosamente!");
      } else if (res.status === 409) {
        // Nombre duplicado
        setSeverity("error");
        setColorMensaje("#F1948A");
        setMensaje(data.message || "El producto ya existe.");
        setDisBtn(false);
      } else {
        // Otro error
        setSeverity("error");
        setColorMensaje("#F1948A");
        setMensaje(data.error || "Error al guardar el producto.");
        setDisBtn(false);
      }
    } catch (err) {
      setSeverity("error");
      setColorMensaje("#F1948A");
      setMensaje("Error de red o servidor.");
      setDisBtn(false);
    } finally {
      // Muestro el snack en todos los casos
      setOpenSnack(true);
    }
  };

  const almacenar = (e) => {
    const { name, value } = e.target;
    setDatosProducto({
      ...datosProducto,
      [name]: value === "" ? null : value,
    });
  };

  //*************************************************************************************************************************************/

  // Cierre de la notificación
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);

    if (severity === "success") {
      // Refrescar datos y cerrar diálogo
      props.onProductoGuardado();
      props.handleCloseAgregarProducto();
      setDisBtn(false);
    }
    // Si fue error, no se cierra el diálogo, solo se reactiva el botón
  };

  return (
    <>
      <Box
        sx={{
          border: "2px solid #2B76A6",
          borderRadius: 1,
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            mt: 0,
            mb: 3,
            display: "flex",
            justifyContent: "flex-start", // alineado a la izquierda
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{
              backgroundColor: "#2B76A6",
              borderBottomRightRadius: "12px", // solo esquina inferior derecha
              padding: "8px 18px",
            }}
          >
            Agregar Producto
          </Typography>
        </DialogTitle>

        <DialogContent>
          <form onSubmit={guardarCrear}>
            <Grid container spacing={2}>
              <Grid item xs={8} mt={1} sx={{ pr: 2 }}>
                <TextField
                  label="Nombre"
                  required
                  size="small"
                  name="nombre"
                  autoComplete="off"
                  fullWidth
                  value={datosProducto.nombre}
                  onChange={almacenar}
                />
              </Grid>

              <Grid item xs={4} mt={1}>
                <FormControl fullWidth size="small">
                  <InputLabel>Unidad</InputLabel>
                  <Select
                    required
                    name="unidad"
                    value={datosProducto.unidad || ""}
                    label="Unidad"
                    onChange={almacenar}
                  >
                    {unidades.map((unidad) => (
                      <MenuItem key={unidad.id} value={unidad.id}>
                        {unidad.unidad} ({unidad.abreviatura})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* BOTONES EN LÍNEA */}
              <Grid item xs={12} mt={3}>
                <Box display="flex" justifyContent="space-between">
                  <Button
                    variant="contained"
                    color="error"
                    onClick={props.handleCloseAgregarProducto}
                  >
                    Volver
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={disBtn}
                  >
                    Guardar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Box>

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AgregarProducto;
